import ProductFragment from './ProductFragment';
export default `
  query ListProducts {
    listProducts {
      items {
        ...ProductFragment
      }
    }
  }
  ${ProductFragment}
`;
